export default "__VITE_ASSET__BqQWqTSM__"